export const BASE_CURRENCY = 'EUR';
export const CC_MIN = 1;
export const CC_MAX = 18;
export const CC_PATTERN = /^([1-9]\d*|)$/;
export const PRICE_PATTERN = /^(|([1-9]\d*|0)(\.\d{0,2})?)$/;
